
import axios from 'axios';
import store from '../redux/store/store';



// API URL'si environment değişkenlerinden alınıyor
const API_MARKETPLACES_URL = import.meta.env.VITE_API_URL;

const productService = {
  addProduct: async (productData, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/Product`,
        productData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  fetchMarketPlaces: async () => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/MarketPlace`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  fetchEcommercePlaces: async () => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/EcommercePlace`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  fetchProducts: async (model, userId, page = 1, pageSize = 10, token) => {

    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product', {
        params: {
          UserId: userId,
          Page: page,
          PageSize: pageSize,
          WithCategory: true,
          WithProductAttribute: false,
          WithProductPlaces: true,
          WithBrand: false,
          WithProductBarcodes: true,
          WithProductImages: true,
          WithProductPriceHistories: false,
          WithProductPrices: false,
          WithProductStockHistories: false,
          WithPurchasePrices: false,
          ...model,
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });


      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  updateProduct: async (updatedData, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.put(
        `/Product`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Ürün güncellenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  addExcel: (data, token) => {

    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.post(`${API_MARKETPLACES_URL}/ProductExcel`, data, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        'Content-Type': 'application/json',
      }
    });
  },
  getExcel: (userId, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams({ userId: userId });
    return axios.get(`${API_MARKETPLACES_URL}/ProductExcel?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        'Content-Type': 'application/json',
      }
    });
  },
  getExcelRunTime: (id) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams();
    queryParams.append('ExcelId', id);
    return axios.get(`${API_MARKETPLACES_URL}/ProductExcelRuntime?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        'Content-Type': 'application/json',
      }
    });
  },

  getPrice: async (id, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/product', {
        params: {
          id: id,
          // UserId: userId,
          WithCategory: false,
          WithProductAttribute: false,
          WithProductPlaces: true,
          WithBrand: false,
          WithProductBarcodes: false,
          WithProductImages: true,
          WithProductPriceHistories: false,
          WithProductPrices: true,
          WithProductStockHistories: false,
          WithPurchasePrices: false
        },
        headers: {
          Authorization: `Bearer ${userToken}`
        },
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },
  getProductDetails: async (id, token, categoryId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product', {
        params: {
          id: id,
          // UserId: userId,
          WithCategory: true,
          WithProductAttribute: true,
          WithProductPlaces: true,
          WithBrand: true,
          WithProductBarcodes: true,
          WithProductImages: true,
          WithProductPriceHistories: false,
          WithProductPrices: true,
          WithProductStockHistories: false,
          WithPurchasePrices: false,
          WithPriceRule: true,
          CategoryId: categoryId
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  fetchProviders: async () => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`${API_MARKETPLACES_URL}/Provider`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data.data.data;
    } catch (error) {
      console.error('Kullanıcıya özel sağlayıcılar çekilirken hata oluştu:', error);
      throw error;
    }
  },


  getSendProducts: async (id, productMainId, token, userId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product', {
        params: {
          productMainId: productMainId,
          id: id,
          WithCategory: true,
          // WithProductAttribute: true,
          WithProductImages: true,
          // WithProductPrices: true,
          WithVariantProduct: true,
          // WithBrand:true
          userId: userId
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },



  sendProduct: async (productData, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/ProductAttribute/CreateRange`,
        productData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  //atribute ler kayıt edilince gönderilecek ürünlerin son halini çeker
  getOutwardSendProducts: async (ids, selectedPlatform, token, selectedPlatformType, categoryId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const params = new URLSearchParams();
      ids.forEach(id => params.append('ids', id));
      params.append('WithCategory', true);
      params.append('WithProductAttribute', true);
      params.append('WithProductImages', true);
      params.append('WithProductPrices', true);
      //params.append('WithVariantProduct', true);
      params.append('WithBrand', true);
      params.append('WithProductBarcodes', true);
      params.append('PageSize', ids?.length);
      params.append('WithPriceRule', true);
      params.append('CategoryId', categoryId);
      if (selectedPlatformType == "ecommerce") {
        params.append('EcommercePlaceId', selectedPlatform);
      } else {
        params.append('MarketPlaceId', selectedPlatform);
      }


      const response = await axios.get('/Product', {
        params,
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  getProductTransfer: (productId) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams({ productId: productId, withMarketpleaces: true });
    return axios.get(`${API_MARKETPLACES_URL}/ProductPlaceTransfer?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        'Content-Type': 'application/json',
      }
    });
  },
  getAllProductTransfer: (query) => {
  const userToken = store.getState()?.auth?.user?.accessToken?.token;
  
  // Tüm parametreleri bir objede topla
  const allParams = {
    userId: query.userId,
    withMarketpleaces: true,
    page: query.page,
    pageSize: query.pageSize,
    productName: query?.productName,
    marketPlaceId: query?.marketPlaceId,
    ecommercePlaceId: query?.ecommercePlaceId,
    startDate: query?.startDate,
    endDate: query?.endDate,
    status: query?.status,
  };
  
  // Boş string olan parametreleri filtrele
  const filteredParams = Object.fromEntries(
    Object.entries(allParams).filter(([key, value]) => value !== "" && value !== undefined && value !== null)
  );
  
  const queryParams = new URLSearchParams(filteredParams);
  
  return axios.get(`${API_MARKETPLACES_URL}/ProductPlaceTransfer?${queryParams.toString()}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json',
    }
  });
},

  fetchSearchProducts: async (model, userId, page = 1, pageSize = 10, search) => {

    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product', {
        params: {
          UserId: userId,
          Page: page,
          PageSize: pageSize,
          WithCategory: true,
          WithProductAttribute: false,
          WithProductPlaces: true,
          WithBrand: false,
          WithProductBarcodes: true,
          WithProductImages: true,
          WithProductPriceHistories: false,
          WithProductPrices: false,
          WithProductStockHistories: false,
          WithPurchasePrices: false,
          title: search
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });


      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },



  updateRangeProduct: async (updatedData) => {
    try {


      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.put(
        `/Product/updateRange`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Ürün güncellenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  getCategoryProducts: async (categoryId, userId, page, marketPlaceId, ecommercePlaceId, pageSize, containsTitle) => {
    console.log(pageSize)
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product', {
        params: {
          categoryId: categoryId,
          MarketPlaceId: marketPlaceId,
          EcommercePlaceId: ecommercePlaceId,
          WithCategory: true,
          WithProductImages: true,
          WithTransferHistories: true,
          userId: userId,
          page: page,
          pageSize: pageSize,
          title: containsTitle
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },


  addPlacesProduct: async (productData) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/Product/PleaceProductCreate`,
        productData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },




  addProductBarcode: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/ProductBarcode`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Güncelleme sırasında bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },
  addProductPrice: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/ProductPrice`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Güncelleme sırasında bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },
  updateProductBarcode: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.put(
        `${API_MARKETPLACES_URL}/ProductBarcode`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Güncelleme sırasında bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },
  updateProductPrice: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.put(
        `${API_MARKETPLACES_URL}/ProductPrice`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Güncelleme sırasında bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },
  addPlaces: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/ProductPlace`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Pleaces kaydı sırasında bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },

  fetchMatchingProducts: async (model, userId, page = 1, pageSize = 10, search) => {

    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product', {
        params: {
          UserId: userId,
          Page: page,
          PageSize: pageSize,
          WithCategory: false,
          WithProductAttribute: true,
          WithProductPlaces: true,
          WithBrand: false,
          WithProductBarcodes: true,
          WithProductImages: true,
          WithProductPriceHistories: false,
          WithProductPrices: true,
          WithProductStockHistories: false,
          WithPurchasePrices: false,
          title: search
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });


      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  deleteProduct: async (id) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.delete(
        `${API_MARKETPLACES_URL}/Product?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          }
        }
      );
      return response;
    } catch (error) {

      console.error("Ürün silinirken bir hata oluştu:", error);
      throw error;
    }
  },
  addProductPleaces: async (productData) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.post(
        `${API_MARKETPLACES_URL}/ProductPlace`,
        productData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  matchingControl: async (model) => {

    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/Product/count', {
        params: {
          ...model,
        },
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });


      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },


  deleteProductAttribute: async (id) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.delete(
        `${API_MARKETPLACES_URL}/ProductAttribute?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          }
        }
      );
      return response;
    } catch (error) {

      console.error("Ürün silinirken bir hata oluştu:", error);
      throw error;
    }
  },

}
export default productService;
